import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryModule } from '@ngx-gallery/core';
import { GALLERY_CONFIG } from '@ngx-gallery/core';

import { CardComponent } from './card/card.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { TableComponent } from './table/table.component';
import { TopNavComponent } from './top-nav/top-nav.component';
import { RightNavComponent } from './right-nav/right-nav.component';
import { UiMaterialModule } from '@takeoff-group/ui/material';
import { RouterModule } from '@angular/router';
import { SubNavComponent } from './sub-nav/sub-nav.component';
import { DialogComponent } from './dialog/dialog.component';
import { DragDropDirective } from './directives/drag-drop.directive';
import { GalleryComponent } from './gallery/gallery.component';
import { LightboxModule } from '@ngx-gallery/lightbox';
import { ExportXlComponent } from './export-xl/export-xl.component';
import { SafePipe } from './pipe/safe.pipe';

@NgModule({
  imports: [
    CommonModule,
    UiMaterialModule,
    RouterModule,
    LightboxModule,
    GalleryModule,
    GalleryModule.withConfig({})
  ],
  declarations: [
    CardComponent,
    BreadcrumbComponent,
    TableComponent,
    TopNavComponent,
    RightNavComponent,
    SubNavComponent,
    DialogComponent,
    DragDropDirective,
    GalleryComponent,
    ExportXlComponent,
    SafePipe
  ],
  exports: [
    CardComponent,
    BreadcrumbComponent,
    TableComponent,
    TopNavComponent,
    RightNavComponent,
    RouterModule,
    UiMaterialModule,
    SubNavComponent,
    DialogComponent,
    DragDropDirective,
    GalleryComponent
  ],
  providers: [
    {
      provide: 'windowObject', useFactory: () => {
        return window;
      }
    },
    {
      provide: GALLERY_CONFIG,
      useValue: {
        dots: true,
        imageSize: 'cover'
      }
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UiComponentsModule { }
